import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './EmbedIframe.module.scss';

const EmbedIframe = ({ url = '', title = '', height = null }) => {
    if (!url) {
        return null;
    }

    return (
        <div className={styles['EmbedIframe']}>
            <iframe
                className={classNames(
                    styles['EmbedIframe__Frame'],
                    !height && styles['EmbedIframe__Frame--Fill']
                )}
                src={url}
                title={title}
                style={height ? { height: `${height}px` } : undefined}
                loading="lazy"
            />
        </div>
    );
};

EmbedIframe.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    height: PropTypes.number,
};

export default EmbedIframe;
